import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";

import CustomModal from "../CustomModal";
import {
  calculateCustomAmount,
  formatMoney,
  getTimeFrame,
  isFlatRateSpot,
  showToast,
} from "../../../utils/helper";

const ConfirmCustomBooking = ({ show, onClose, spot, data, onConfirm }) => {
  const [price, setPrice] = useState(data.offerPrice);
  const isFlat = isFlatRateSpot(spot);

  const timeFrameBlock = getTimeFrame(
    data.bookingDate,
    data.arrivalTime,
    data.endDate,
    data.endTime,
  );

  // Flat-rate spots charge the same amount regardless of duration.
  const amount = isFlat
    ? formatMoney(spot.flatRate)
    : calculateCustomAmount(
        spot.ratePerHour,
        data.bookingDate,
        data.arrivalTime,
        data.endDate,
        data.endTime,
      );

  const submitNow = () => {
    if (parseFloat(price) > 50) {
      onConfirm(price);
    } else {
      showToast("error", "Offered amount must be more than $50");
    }
  };

  return (
    <CustomModal
      show={show}
      title="Confirm Booking"
      onClose={onClose}
      className="confirm-custom-booking"
    >
      <div className="confirm-summary mb-3">
        <div className="fw-bold mb-2">{spot.name}</div>
        <div className="d-flex justify-content-between align-items-end">
          <div className="text-muted">
            {isFlat
              ? "Flat Rate"
              : `$${formatMoney(spot.ratePerHour)} Per Hour × ${timeFrameBlock || ""}`}
          </div>
          <div className="confirm-total">${amount}</div>
        </div>
      </div>

      <Form.Group className="mb-3">
        <Form.Label className="fw-bold">Offer Amount</Form.Label>
        <div className="input-group">
          <span className="input-group-text">$</span>
          <Form.Control
            type="number"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            disabled
          />
        </div>
      </Form.Group>

      <div className="d-grid">
        <Button
          variant=""
          className="btn-primary btn btn-primary"
          onClick={submitNow}
        >
          <span>Confirm Offer</span>
        </Button>
      </div>

      <div className="text-center mt-2">
        <Button onClick={onClose}>
          <span>Cancel</span>
        </Button>
      </div>
    </CustomModal>
  );
};

export default ConfirmCustomBooking;
